import { useFormik } from 'formik'
import * as Yup from 'yup';
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import TailwindLayout from 'TailwindcssComponents/TailwindLayout'
import TopBar from 'TailwindcssComponents/TopBar'
import FooterTailwind from 'TailwindcssComponents/Footer'
import SeatSetupModel from './Models/seatSetupModel'

export default function AddEventZone() {
    const { venueId } = useParams();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [seatSetupModelOpen, setSeatSetupModelOpen] = useState(false);
    const [seatsData, setSeatsData] = useState([]);
    const navigate = useNavigate();

    const newZone = useFormik({
        initialValues: {
            name: '',
            capacity: '',
            totalSeatsPerRows: '',
            totalRows: '',
            venueId: venueId,
            isSeat: false,
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Required'),
            capacity: Yup.number().required('Required'),
            isSeat: Yup.boolean(),
        }),
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const response = await axios.post(`${apiUrl}event-service/venue-zone`, values, {
                    headers: {
                        'Authorization': `Bearer ${bearerToken}`,
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'accept': 'application/json',
                    },
                });

                if (!response.data.success) {
                    throw new Error(response.data.message);
                }

                const zoneId = response.data.data.id;

                if (zoneId && values.isSeat && seatsData?.seats?.length > 0) {
                    const seatPayload = {
                        zoneId: zoneId,
                        seats: seatsData.seats.map(({ name, row, column }) => ({
                            name,
                            row,
                            column,
                            zoneId,
                        })),
                    };

                    const seatResponse = await axios.post(`${apiUrl}event-service/venue-seat/bulk`, seatPayload, {
                        headers: {
                            'Authorization': `Bearer ${bearerToken}`,
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'accept': 'application/json',
                        },
                    });

                    if (!seatResponse.data.success) {
                        throw new Error(seatResponse.data.message);
                    }
                }

                toast.success('Zone has been successfully created!');
                setTimeout(() => {
                    navigate(-1);
                    setIsSubmitting(false);
                }, 1000);

            } catch (error) {
                setIsSubmitting(false);
                console.error('Error inserting data:', error.response?.data.message || error.message);
                toast.error(`Error: ${error.response?.data.message || error.message}`);
            }
        },
    });

    const openSeatSetupModel = () => {
        setSeatSetupModelOpen(true);
    }

    const closeSeatSetupModel = () => {
        setSeatSetupModelOpen(false);
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="max-w-7xl mx-auto p-12 mb-8 min-h-screen">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <form onSubmit={newZone.handleSubmit} className="p-6 space-y-6">
                        <h2 className="text-xl font-semibold text-gray-900 mb-4 border-b pb-4">Create New Zone</h2>
                        <div>
                            <label className="block text-sm font-medium mb-2">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={newZone.values.name}
                                onChange={newZone.handleChange}
                                onBlur={newZone.handleBlur}
                                placeholder="zone name"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-2">
                                Capacity <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="number"
                                name="capacity"
                                value={newZone.values.capacity}
                                onChange={newZone.handleChange}
                                onBlur={newZone.handleBlur}
                                min={1}
                                placeholder="e.g 100"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300" />
                        </div>
                        <div className="flex gap-6 mt-4">
                            <p>Seat Setup</p>
                            <div className="flex gap-6">
                                {[{ label: "Yes", value: "true" }, { label: "No", value: "false" }].map((option) => (
                                    <label key={option.value} className="flex items-center space-x-3 text-gray-700">
                                        <input
                                            type="radio"
                                            name="isSeat"
                                            value={option.value}
                                            onChange={(e) => {
                                                newZone.setFieldValue("isSeat", e.target.value);
                                                if (e.target.value === "false") {
                                                    newZone.setFieldValue("totalRows", "");
                                                    newZone.setFieldValue("totalSeatsPerRows", "");
                                                }
                                            }}
                                            checked={String(newZone.values.isSeat) === option.value}
                                            className="form-radio h-5 w-5 text-blue-600"
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        {newZone.values.isSeat === "true" && (
                            <button type='button' onClick={openSeatSetupModel} className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition mt-4">
                                Create Seat Layout
                            </button>
                        )}
                        {/* Submit Button */}
                        <div className="mt-6 flex items-center">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50"
                            >
                                {isSubmitting ? 'Saving...' : 'Save'}
                            </button>
                            {isSubmitting && (
                                <span className="ml-2 text-gray-600">Saving....</span>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            <SeatSetupModel
                open={seatSetupModelOpen}
                onClose={closeSeatSetupModel}
                onSave={(seatData) => {
                    setSeatsData(seatData);
                    newZone.setFieldValue('totalRows', seatData.rows);
                    newZone.setFieldValue('totalSeatsPerRows', seatData.columns);
                }}
            />
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}